/* Marknadssidan och de juridiska sidorna. Mobil först, inga externa resurser, rörelse bara när den är tillåten. */
.landing,
.legal {
  --site-max: 1160px;
  min-height: 100vh;
  background: var(--bg);
  color: var(--text);
  font-size: 1rem;
}
.landing main:focus,
.legal main:focus {
  outline: none;
}
.site-wrap {
  width: 100%;
  max-width: var(--site-max);
  margin: 0 auto;
  padding: 0 var(--space-4);
}
.site-narrow {
  max-width: 820px;
}

/* ---------- Sidhuvud ---------- */
.site-header {
  position: sticky;
  top: 0;
  z-index: 50;
  background: color-mix(in srgb, var(--bg) 82%, transparent);
  backdrop-filter: saturate(1.4) blur(14px);
  border-bottom: 1px solid var(--border);
}
.site-header-row {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  min-height: 68px;
}
.site-brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-family: var(--font-display);
  font-weight: 750;
  font-size: var(--text-xl);
  letter-spacing: -0.025em;
  color: var(--text);
  text-decoration: none;
}
.site-nav {
  display: none;
}
.site-nav ul {
  display: flex;
  gap: var(--space-1);
  list-style: none;
  margin: 0;
  padding: 0;
}
.site-nav a {
  display: inline-flex;
  align-items: center;
  min-height: 38px;
  padding: 0 14px;
  border-radius: var(--radius-pill);
  color: var(--text);
  font-size: var(--text-s);
  font-weight: 550;
  text-decoration: none;
}
.site-nav a:hover {
  background: var(--surface-2);
  color: var(--text);
}
.site-header-actions {
  margin-left: auto;
  display: flex;
  gap: var(--space-2);
}
.site-header .site-header-cta {
  display: none;
}
.btn.lbtn {
  min-height: 54px;
  padding: 0 30px;
  font-size: 1rem;
  border-radius: var(--radius-pill);
}

/* ---------- Hjälte ---------- */
.hero {
  padding: var(--space-7) 0 var(--space-7);
  background: var(--bg);
}
.hero-grid {
  display: grid;
  gap: var(--space-7);
}
/* Rubrik, ingress och knappar vänsterställda, som i en tidning. Ingen etikett ovanför och ingen markering bakom orden. */
.hero-copy {
  display: grid;
  gap: var(--space-5);
  align-items: end;
}
.hero h1 {
  font-family: var(--font-display);
  font-size: var(--text-hero);
  line-height: 1;
  letter-spacing: -0.02em;
  font-weight: 700;
  max-width: 14ch;
  text-wrap: balance;
}
.hero-lead {
  margin: 0;
  max-width: 52ch;
  font-size: clamp(1.0625rem, 1rem + 0.5vw, 1.3125rem);
  line-height: 1.5;
  color: var(--text-2);
  text-wrap: pretty;
}
.hero-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
  margin-top: var(--space-6);
}
.hero-note {
  margin-top: var(--space-3);
  color: var(--text-3);
}

/* ---------- Utdrag ur tankekartan ---------- */
/* Samma klasser som tankekartan i tjänsten (mindmap.css), så att bilden ser ut som produkten. */
.shot {
  margin: var(--space-7) 0 0;
}
.shot-frame {
  padding: var(--space-3);
  border: 1px solid var(--border);
  border-radius: var(--radius-l);
  background: var(--surface);
}
.shot-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
  padding: 4px 4px 10px;
}
.shot-tool {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 32px;
  padding: 0 12px;
  border-radius: var(--radius-pill);
  font-size: var(--text-s);
  font-weight: 600;
  color: var(--text);
}
.shot-tool-ghost {
  border: 1px solid var(--border);
}
.shot-search {
  flex: 1 1 220px;
  max-width: 360px;
  min-height: 36px;
  display: flex;
  align-items: center;
  padding: 0 12px;
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-s);
  color: var(--text-3);
  font-size: var(--text-s);
}
.shot-summary {
  margin: 0 4px 10px;
  font-size: var(--text-s);
  color: var(--text-2);
}
.shot-stage {
  position: relative;
  overflow: hidden;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background:
    radial-gradient(circle, var(--border) 1px, transparent 1px) 0 0 / 22px 22px,
    var(--bg);
}
.shot-inner {
  position: absolute;
  top: 0;
  left: 0;
  transform-origin: 0 0;
}
.shot .shot-inner .mm-node {
  cursor: default;
}
.shot-narrow {
  display: none;
}
.shot figcaption {
  margin-top: var(--space-3);
  max-width: 70ch;
  color: var(--text-3);
  font-size: var(--text-s);
}
@media (max-width: 760px) {
  .shot-wide,
  .shot-bar .shot-hide-small {
    display: none;
  }
  .shot-narrow {
    display: block;
  }
}


/* Tankekartans stilar för utdraget, kopierade ur mindmap.css och avgränsade till .shot. Startsidan laddas före
   appens grundstilar, så mindmap.css kan inte importeras här utan att ändra ordningen för hela appen. */
.shot .mm-edge {
  fill: none;
  stroke: var(--border-strong);
  stroke-width: 1.5;
}
.shot .mm-edge-gap {
  stroke-dasharray: 5 5;
}
.shot .mm-node {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px 8px 10px;
  text-align: left;
  color: var(--text);
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: 0 1px 2px rgb(0 0 0 / 0.04);
  cursor: pointer;
  font: inherit;
  height: var(--mm-h);
  transition:
    transform 420ms var(--ease),
    border-color var(--dur) var(--ease),
    box-shadow var(--dur) var(--ease);
}
/* Samma typfärger som i tankekartan och Projektkartan (mindmap.css laddas inte på startsidan). */
.shot .mm-node.mm-capability {
  background: color-mix(in srgb, var(--kind-capability-soft) 60%, var(--surface));
  border-left: 6px solid var(--kind-capability);
}
.shot .mm-node.mm-need {
  background: color-mix(in srgb, var(--kind-need-soft) 60%, var(--surface));
  border-left: 6px solid var(--kind-need);
}
.shot .mm-node.mm-requirement {
  background: color-mix(in srgb, var(--kind-requirement-soft) 60%, var(--surface));
  border-left: 6px solid var(--kind-requirement);
}
.shot .mm-node.mm-test {
  background: color-mix(in srgb, var(--kind-test-soft) 60%, var(--surface));
  border-left: 6px solid var(--kind-test);
}
.shot .mm-center {
  border: 2px solid var(--ink);
  box-shadow: var(--ring);
  cursor: default;
  z-index: 1;
}
.shot .mm-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 1px;
}
.shot .mm-key {
  font-size: var(--text-xs);
  line-height: 1.2;
}
.shot .mm-title {
  font-size: var(--text-s);
  font-weight: 600;
  line-height: 1.25;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
  overflow-wrap: anywhere;
}
/* På mobil är posterna smala, så titeln får fler rader i stället för att kortas. */
.shot-narrow .mm-title {
  -webkit-line-clamp: unset;
}
.shot .mm-status {
  font-size: var(--text-xs);
  line-height: 1.2;
}
.shot .mm-ring {
  position: relative;
  flex: 0 0 28px;
  width: 28px;
  height: 28px;
  display: inline-grid;
  place-items: center;
  vertical-align: middle;
}
.shot .mm-ring-bg {
  position: absolute;
  inset: 0;
}
.shot .mm-ring > svg:not(.mm-ring-bg) {
  position: relative;
}
.shot .mm-ring-bg circle {
  fill: var(--surface);
  stroke-width: 2.5;
}
.shot .mm-ring-hel .mm-ring-bg circle {
  stroke: var(--ok);
  fill: var(--ok-soft);
}
.shot .mm-ring-hel {
  color: var(--ok);
}
.shot .mm-ring-bruten .mm-ring-bg circle {
  stroke: var(--bad);
  fill: var(--bad-soft);
  stroke-dasharray: 18 6;
}
.shot .mm-ring-bruten {
  color: var(--bad);
}
.shot .mm-ring-streckad .mm-ring-bg circle {
  stroke: var(--warn);
  stroke-dasharray: 4 3;
}
.shot .mm-ring-streckad {
  color: var(--warn);
}
.shot .mm-ring-prickad .mm-ring-bg circle {
  stroke: var(--border-strong);
  stroke-dasharray: 1.5 3;
  stroke-linecap: round;
}
.shot .mm-ring-prickad,
.shot .mm-ring-tom {
  color: var(--border-strong);
}
.shot .mm-ring-halv .mm-ring-bg circle {
  stroke: var(--info);
  stroke-dasharray: 35 35;
}
.shot .mm-ring-halv {
  color: var(--info);
}
.shot .mm-ring-tom .mm-ring-bg circle {
  stroke: var(--border);
}
/* Listor utan kort: en tunn linje ovanför varje punkt, som i ett tryckt dokument. */
.points {
  list-style: none;
  margin: var(--space-6) 0 0;
  padding: 0;
  display: grid;
  gap: var(--space-5) var(--space-6);
}
.points > li {
  padding-top: var(--space-4);
  border-top: 1px solid var(--text);
}
.points h3 {
  font-size: var(--text-l);
  margin-bottom: var(--space-2);
}
.points p {
  color: var(--text-2);
  max-width: 48ch;
}
.points .lstep-name {
  margin-bottom: var(--space-1);
  color: var(--text);
  font-size: var(--text-s);
  font-weight: 700;
}

/* ---------- Sektioner ---------- */
.band {
  padding: var(--space-8) 0;
}
.band-alt {
  background: var(--surface);
  border-top: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
}
.lp-title {
  font-family: var(--font-display);
  font-size: clamp(2rem, 1.3rem + 3vw, 3.25rem);
  line-height: 1.04;
  font-weight: 700;
  letter-spacing: -0.016em;
  max-width: 20ch;
}
.section-lead {
  margin-top: var(--space-3);
  max-width: 62ch;
  color: var(--text-2);
  font-size: var(--text-l);
}
.cards-3,
.cards-2,
.lsteps,
.plans,
.dev-list {
  list-style: none;
  margin: var(--space-6) 0 0;
  padding: 0;
  display: grid;
  gap: var(--space-4);
}
.lcard {
  padding: var(--space-5);
  border: 1px solid var(--border);
  border-radius: var(--radius-l);
  background: var(--surface);
}
.band-alt .lcard {
  background: var(--bg);
}
.lcard h3 {
  font-size: var(--text-l);
  margin-bottom: var(--space-2);
}
.lcard p {
  color: var(--text-2);
}

.lstep {
  display: flex;
  gap: var(--space-4);
  padding: var(--space-4);
  border-radius: var(--radius-l);
  border: 1px solid var(--border);
  background: var(--bg);
}
.lstep-num {
  flex: none;
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border: 1px solid var(--border-strong);
  border-radius: 50%;
  color: var(--text);
  font-weight: 650;
  font-variant-numeric: tabular-nums;
}
.lstep-name {
  font-size: var(--text-xs);
  font-weight: 700;
  color: var(--brand-text);
}
.lstep h3 {
  font-size: var(--text-l);
  margin: 2px 0 var(--space-1);
}
.lstep p:last-child {
  color: var(--text-2);
}

/* Jämförelsen */
.table-scroll {
  margin-top: var(--space-6);
  overflow-x: auto;
  border: 1px solid var(--border);
  border-radius: var(--radius-l);
  background: var(--surface);
}
.compare {
  width: 100%;
  min-width: 640px;
  border-collapse: collapse;
  font-size: var(--text-s);
}
.compare caption {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}
.compare th,
.compare td {
  padding: var(--space-3);
  border-bottom: 1px solid var(--border);
  text-align: left;
  vertical-align: top;
}
.compare thead th {
  font-size: var(--text-xs);
  color: var(--text-2);
  background: var(--surface-2);
}
.compare tbody th {
  font-weight: 600;
  max-width: 30ch;
}
.compare tr:last-child > * {
  border-bottom: 0;
}
.compare .compare-us {
  background: var(--brand-soft);
}
.compare thead .compare-us {
  color: var(--brand-text);
}
.cell-ja {
  color: var(--ok);
  font-weight: 650;
}
.cell-delvis {
  color: var(--warn);
}
.cell-nej {
  color: var(--text-3);
}
.compare-note {
  margin-top: var(--space-3);
}

/* Utvecklare: mörk yta i båda teman */
.band-dark {
  --dk-surface: #1c2127;
  --dk-border: #343b45;
  --dk-text: #e6e9ed;
  --dk-text-2: #b7bfc8;
  background: var(--surface);
  border-top: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
}
.dev-grid {
  display: grid;
  gap: var(--space-6);
}
.dev-list li h3 {
  font-size: var(--text-l);
  margin-bottom: var(--space-1);
}
.dev-list li p {
  color: var(--text-2);
}
.dev-list code {
  font-family: var(--font-mono);
  font-size: 0.9em;
  padding: 1px 5px;
  border-radius: var(--radius-s);
  background: var(--surface-3);
  color: var(--text);
}
.code-stack {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  min-width: 0;
}
.code-card {
  border: 1px solid var(--dk-border);
  border-radius: var(--radius);
  background: var(--dk-surface);
  overflow: hidden;
}
.code-title {
  padding: var(--space-2) var(--space-3);
  border-bottom: 1px solid var(--dk-border);
  font-family: var(--font-mono);
  font-size: var(--text-xs);
  color: var(--dk-text-2);
}
.code-card pre {
  margin: 0;
  padding: var(--space-3);
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  font-family: var(--font-mono);
  font-size: 0.8125rem;
  line-height: 1.6;
  color: var(--dk-text);
}
.c-k {
  color: #9cc3f5;
}
.c-s {
  color: #a8d8b9;
}
.c-p {
  color: #e8c580;
}
.c-o {
  color: var(--dk-text-2);
}
.c-c {
  color: #98a2ad;
}

/* Priser */
.plan {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding: var(--space-5);
  border: 1px solid var(--border);
  border-radius: var(--radius-l);
  background: var(--bg);
}
.plan h3 {
  font-size: var(--text-xl);
}
.plan-featured {
  border-color: var(--brand);
  box-shadow: 0 0 0 1px var(--brand), var(--shadow-2);
}
.plan-price {
  font-weight: 700;
  color: var(--text-2);
}
.plan-list {
  flex: 1;
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  color: var(--text-2);
}
.plan-list li {
  display: flex;
  gap: var(--space-2);
}
.plan-list li::before {
  content: "✓";
  color: var(--ok);
  font-weight: 800;
}
.plan .btn {
  align-self: flex-start;
  min-height: 42px;
}

/* Vanliga frågor */
.faq {
  margin-top: var(--space-5);
  border-top: 1px solid var(--border);
}
.faq details {
  border-bottom: 1px solid var(--border);
}
.faq summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  min-height: 56px;
  padding: var(--space-3) 0;
  font-weight: 650;
  font-size: var(--text-l);
  cursor: pointer;
  list-style: none;
}
.faq summary::-webkit-details-marker {
  display: none;
}
.faq summary::after {
  content: "+";
  flex: none;
  display: grid;
  place-items: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--surface-2);
  color: var(--text-2);
  font-weight: 700;
}
.faq details[open] summary::after {
  content: "–";
}
.faq details p {
  padding: 0 0 var(--space-4);
  color: var(--text-2);
  max-width: 68ch;
}

/* Avslutande uppmaning */
.cta-band {
  padding-top: 0;
}
.cta {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-3);
  padding: var(--space-7) var(--space-5);
  border-radius: var(--radius-xl);
  color: #f5f2eb;
  background: #16161a;
}
.cta h2 {
  font-family: var(--font-display);
  font-size: clamp(2rem, 1.3rem + 3vw, 3.5rem);
  line-height: 1.02;
  font-weight: 700;
  letter-spacing: -0.016em;
  max-width: 16ch;
}
.cta p {
  font-size: var(--text-l);
  opacity: 0.95;
}
.cta .btn {
  background: transparent;
  border-color: rgb(255 255 255 / 70%);
  color: #fff;
}
.cta .btn-primary {
  background: #ff9e87;
  border-color: #ff9e87;
  color: #16161a;
}
.cta :focus-visible {
  outline-color: #fff;
}

/* ---------- Sidfot ---------- */
.site-footer {
  padding: var(--space-7) 0 var(--space-5);
  border-top: 1px solid var(--border);
  background: var(--surface);
  color: var(--text-2);
}
.site-footer-grid {
  display: grid;
  gap: var(--space-5);
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.site-footer-grid > :first-child {
  grid-column: 1 / -1;
}
.site-brand-footer {
  font-size: var(--text-m);
}
.site-footer-h {
  font-size: var(--text-xs);
  color: var(--text-3);
  margin-bottom: var(--space-2);
}
.site-footer ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.site-footer ul a {
  display: inline-block;
  padding: 5px 0;
  max-width: 100%;
  hyphens: auto;
  overflow-wrap: break-word;
  color: var(--text-2);
  font-size: var(--text-s);
}
.site-footer ul a:hover {
  color: var(--brand-text);
}
.site-footer-base {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: var(--space-2);
  margin-top: var(--space-6);
  padding-top: var(--space-4);
  border-top: 1px solid var(--border);
  color: var(--text-3);
}

/* ---------- Juridiska sidor ---------- */
.legal-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: var(--space-6);
  padding-top: var(--space-6);
  padding-bottom: var(--space-7);
}
.legal-nav ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}
.legal-nav a {
  display: inline-flex;
  align-items: center;
  min-height: 36px;
  padding: 0 var(--space-3);
  border: 1px solid var(--border);
  border-radius: var(--radius-s);
  color: var(--text-2);
  font-size: var(--text-s);
  text-decoration: none;
  background: var(--surface);
}
.legal-nav a[aria-current="page"] {
  background: var(--brand-soft);
  border-color: var(--brand);
  color: var(--brand-text);
  font-weight: 650;
}
.legal-doc {
  max-width: 72ch;
  font-size: 1rem;
  line-height: 1.65;
}
.legal-doc h1 {
  hyphens: auto;
  overflow-wrap: break-word;
  font-size: clamp(1.75rem, 5vw, 2.5rem);
  font-weight: 800;
  letter-spacing: -0.02em;
}
.legal-updated {
  margin-top: var(--space-2);
  color: var(--text-3);
  font-size: var(--text-s);
}
.legal-doc h2 {
  font-size: var(--text-xl);
  margin-top: var(--space-6);
}
.legal-doc h3 {
  font-size: var(--text-l);
  margin-top: var(--space-5);
}
.legal-doc p,
.legal-doc ul,
.legal-doc ol,
.legal-doc .legal-table-wrap {
  margin-top: var(--space-3);
}
.legal-doc ul,
.legal-doc ol {
  padding-left: 1.4em;
}
.legal-doc li + li {
  margin-top: var(--space-1);
}
.legal-lead {
  margin-top: var(--space-4) !important;
  font-size: var(--text-l);
  color: var(--text-2);
}
.legal-table-wrap {
  hyphens: auto;
  overflow-wrap: anywhere;
}
.legal-doc table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  font-size: var(--text-s);
}
.legal-doc th,
.legal-doc td {
  padding: var(--space-2) var(--space-3);
  border: 1px solid var(--border);
  text-align: left;
  vertical-align: top;
}
.legal-doc th {
  background: var(--surface-2);
}
.legal-doc code {
  font-family: var(--font-mono);
  font-size: 0.9em;
  padding: 1px 5px;
  border-radius: 4px;
  background: var(--surface-2);
}
.legal-box {
  margin-top: var(--space-4);
  padding: var(--space-4);
  border-left: 4px solid var(--brand);
  border-radius: var(--radius-s);
  background: var(--brand-soft);
}

/* ---------- Större skärmar ---------- */
@media (min-width: 560px) {
  .site-wrap {
    padding: 0 var(--space-5);
  }
  .site-header .site-header-cta {
    display: inline-flex;
  }
  .cards-2,
  .lsteps {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .site-footer-grid {
    grid-template-columns: 2fr repeat(3, minmax(0, 1fr));
  }
  .site-footer-grid > :first-child {
    grid-column: auto;
  }
}

@media (min-width: 900px) {
  .hero-copy {
    grid-template-columns: minmax(0, 1.25fr) minmax(0, 1fr);
    gap: var(--space-7);
  }
  .points {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .points-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .site-nav {
    display: block;
    margin-left: var(--space-4);
  }
  .hero-grid {
    gap: var(--space-7);
  }
  .hero {
    padding: var(--space-8) 0;
  }
  .cta {
    padding: var(--space-8) var(--space-7);
  }
  .cards-3,
  .plans {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .lsteps {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .cards-2 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .dev-grid {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    align-items: start;
  }
  .legal-grid {
    grid-template-columns: 220px minmax(0, 1fr);
  }
  .legal-nav {
    position: sticky;
    top: 84px;
    align-self: start;
  }
  .legal-nav ul {
    flex-direction: column;
  }
  .legal-nav a {
    border-radius: var(--radius-s);
    width: 100%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .landing *,
  .landing *::before,
  .landing *::after {
    animation: none !important;
    transition: none !important;
  }
}
